var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSendSms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.5079 33.3214C72.9944 33.3214 80.6847 25.9741 80.6847 16.9107C80.6847 7.84732 72.9944 0.5 63.5079 0.5C54.0214 0.5 46.3311 7.84732 46.3311 16.9107C46.3311 25.9741 54.0214 33.3214 63.5079 33.3214Z",
    fill: "#1696E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M67.6826 10.9861C67.6826 13.1911 65.8152 14.9752 63.5073 14.9752C61.1995 14.9752 59.332 13.1911 59.332 10.9861C59.332 8.78121 61.1995 6.99707 63.5073 6.99707C65.8152 6.99707 67.6826 8.78121 67.6826 10.9861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M63.5075 14.9746C59.2265 14.9746 55.7559 18.2904 55.7559 22.3805C55.7559 23.4577 56.672 24.3161 57.7995 24.3161H69.2331C70.3606 24.3161 71.259 23.4408 71.259 22.3805C71.259 18.2904 67.7884 14.9746 63.5075 14.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M73.3732 12.3324C73.3732 14.3185 71.682 15.9175 69.6208 15.9175C69.0218 15.3789 68.3347 14.9413 67.5771 14.5878C68.4932 13.6284 69.057 12.3829 69.057 10.9859C69.057 10.2453 68.8984 9.52155 68.599 8.88195C68.9337 8.79779 69.2684 8.73047 69.6208 8.73047C71.6996 8.73047 73.3732 10.3463 73.3732 12.3156V12.3324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M76.5799 22.583C76.5799 23.5592 75.7696 24.3335 74.7478 24.3335H71.929C72.3694 23.7949 72.6161 23.1216 72.6161 22.3979C72.6161 19.8395 71.4533 17.5336 69.6035 15.9346C71.5414 15.9346 73.2679 16.6752 74.5363 17.887C75.8048 19.0821 76.5799 20.7652 76.5799 22.5998V22.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M53.6602 12.3324C53.6602 14.3185 55.3514 15.9175 57.4126 15.9175C58.0116 15.3789 58.6987 14.9413 59.4562 14.5878C58.5401 13.6284 57.9764 12.3829 57.9764 10.9859C57.9764 10.2453 58.1349 9.52155 58.4344 8.88195C58.0997 8.79779 57.765 8.73047 57.4126 8.73047C55.3338 8.73047 53.6602 10.3463 53.6602 12.3156V12.3324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M50.4355 22.583C50.4355 23.5592 51.2459 24.3335 52.2677 24.3335H55.0865C54.6461 23.7949 54.3994 23.1216 54.3994 22.3979C54.3994 19.8395 55.5622 17.5336 57.412 15.9346C55.4741 15.9346 53.7476 16.6752 52.4791 17.887C51.2107 19.0821 50.4355 20.7652 50.4355 22.5998V22.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.3564 71.1758V79.6588C15.2717 79.6588 19.2355 75.8549 19.2355 71.1758H10.3564Z",
    fill: "#00C880"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M10.3564 80.5002C9.86317 80.5002 9.47559 80.1299 9.47559 79.6586C9.47559 79.1873 9.86317 78.817 10.3564 78.817C14.7608 78.817 18.3547 75.3834 18.3547 71.1756C18.3547 70.7043 18.7423 70.334 19.2356 70.334C19.7288 70.334 20.1164 70.7043 20.1164 71.1756C20.1164 76.326 15.7297 80.5002 10.3564 80.5002Z",
    fill: "#192C62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M54.8929 72.1179H7.44964C3.71478 72.1179 0.666992 69.2061 0.666992 65.6378V31.2174C0.666992 27.6492 3.71478 24.7373 7.44964 24.7373H36.3243C36.8705 24.7373 37.3109 25.1581 37.3109 25.6799C37.3109 26.2016 36.8705 26.6224 36.3243 26.6224H7.44964C4.80705 26.6224 2.65774 28.6759 2.65774 31.2006V65.621C2.65774 68.1457 4.80705 70.1991 7.44964 70.1991H54.8929C57.5355 70.1991 59.6848 68.1457 59.6848 65.621V42.9321C59.6848 42.4104 60.1253 41.9896 60.6714 41.9896C61.2175 41.9896 61.658 42.4104 61.658 42.9321V65.621C61.658 69.1892 58.6102 72.1011 54.8753 72.1011L54.8929 72.1179Z",
    fill: "#192C62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M49.2906 56.498H13.0519C11.5632 56.498 10.3564 57.651 10.3564 59.0733V59.0901C10.3564 60.5123 11.5632 61.6653 13.0519 61.6653H49.2906C50.7793 61.6653 51.986 60.5123 51.986 59.0901V59.0733C51.986 57.651 50.7793 56.498 49.2906 56.498Z",
    fill: "#1696E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M49.2906 45.8438H13.0519C11.5632 45.8438 10.3564 46.9967 10.3564 48.419V48.4358C10.3564 49.858 11.5632 51.011 13.0519 51.011H49.2906C50.7793 51.011 51.986 49.858 51.986 48.4358V48.419C51.986 46.9967 50.7793 45.8438 49.2906 45.8438Z",
    fill: "#1696E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M32.9242 35.2061H13.0519C11.5632 35.2061 10.3564 36.359 10.3564 37.7813V37.7981C10.3564 39.2204 11.5632 40.3733 13.0519 40.3733H32.9242C34.4128 40.3733 35.6196 39.2204 35.6196 37.7981V37.7813C35.6196 36.359 34.4128 35.2061 32.9242 35.2061Z",
    fill: "#FFBA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M59.3321 29.3827L47.0528 42.9488C46.63 43.4201 45.8196 43.1845 45.7316 42.5785L44.8683 36.9063C44.8331 36.6202 44.9564 36.3341 45.2207 36.1826L53.3951 31.2846L44.2165 34.2806C43.9346 34.3648 43.6351 34.2975 43.4413 34.1123L39.4598 30.3084C39.0018 29.8708 39.3012 29.0965 39.9531 29.0797L58.7331 28.1876C59.4025 28.154 59.7725 28.8946 59.3497 29.3827H59.3321Z",
    fill: "#192C62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendSms);
export default __webpack_public_path__ + "static/media/icon-send-sms.b993c92fca51d588b959d4a1bd77f8b3.svg";
export { ForwardRef as ReactComponent };